"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const Dots_1 = __importDefault(require("../Dots"));
const Tooltip_1 = __importDefault(require("../Tooltip"));
const makeMyClasses = props => {
    const color = props.color
        ? typeof props.color === 'string'
            ? lib_palette_1.default[props.color]
            : props.color
        : lib_palette_1.default.secondary;
    const backgroundColor = props.background === 'transparent'
        ? 'transparent'
        : color[props.disabled || props.background
            ? 'background'
            : props.selected
                ? 'light'
                : 'main'];
    const borderColor = color === lib_palette_1.default.White
        ? lib_palette_1.default.InputBorderGrey.main
        : props.background
            ? color.main
            : color.dark;
    const padding = props.round
        ? 0
        : props.icon && (props.small || props.tiny)
            ? '6'
            : props.iconRight && (props.small || props.tiny)
                ? '6'
                : props.icon
                    ? '7px 16px 7px 7px'
                    : props.iconRight
                        ? '7px 7px 7px 16px'
                        : props.tiny
                            ? '3px 4px'
                            : props.small
                                ? '6px 8px'
                                : '7px 16px';
    return {
        root: {
            backgroundColor,
            pointerEvents: props.noEvents ? 'none' : undefined,
            color: props.background ? color.main : color.contrastText,
            width: props.round ? (props.tiny ? 20 : props.small ? 26 : 34) : undefined,
            height: props.round ? (props.tiny ? 20 : props.small ? 26 : 34) : undefined,
            minWidth: props.round
                ? props.tiny
                    ? 20
                    : props.small
                        ? 26
                        : 34
                : props.icon
                    ? 24
                    : props.tiny
                        ? 34
                        : props.small
                            ? 44
                            : 120,
            boxShadow: props.shadow ? `4px 4px 4px ${lib_palette_1.default.LavendarGrey.main}` : undefined,
            borderRadius: props.round ? '50%' : 6,
            margin: props.margin,
            borderWidth: props.bordered ? 1 : 0,
            borderStyle: 'solid',
            borderColor,
            overflow: props.nowrap ? 'hidden' : undefined,
            whiteSpace: props.nowrap ? 'nowrap' : undefined,
            padding: padding,
            fontSize: props.tiny ? 10 : 14,
            lineHeight: props.tiny ? '12px' : '14px',
            '&:hover': {
                backgroundColor: color[props.background ? 'background' : props.lighten ? 'light' : 'dark'],
                color: props.background ? color.dark : color.contrastText,
            },
        },
        label: {
            flexDirection: !!props.iconAbove ? 'column' : undefined,
            justifyContent: props.justify || 'center',
        },
        labelText: {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            minWidth: props.minLabelWidth,
            maxWidth: props.maxLabelWidth,
        },
        icon: {
            marginRight: 0,
        },
        iconAbove: {
            display: 'block',
            margin: 'auto',
            marginBottom: 2,
        },
        badge: {
            position: 'absolute',
            top: -4,
            right: -4,
            backgroundColor: lib_palette_1.default.CoralRed.main,
            color: lib_palette_1.default.White.main,
            borderRadius: 10,
            height: 16,
            width: 16,
            fontSize: 12,
            lineHeight: '16px',
        },
    };
};
exports.Button = react_1.default.forwardRef((props, ref) => {
    const { tooltip, children, label, icon, iconRight, iconAbove, fullWidth, onClick, onMouseEnter, onMouseLeave, badgeCount, link, target, disabled, classes, style, loading, minLabelWidth, submit = false, tabIndex, component, } = props;
    const href = link ? (link.startsWith('http') ? link : '#' + link) : undefined;
    const handleClick = (0, react_1.useCallback)(e => {
        if (!disabled && !loading && onClick)
            onClick(e);
    }, [disabled, loading, onClick]);
    const myCss = (0, web_css_1.default)(makeMyClasses, [props], classes);
    const innards = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        !!badgeCount && react_1.default.createElement("div", { className: myCss.badge }, badgeCount),
        !!iconAbove && !loading && (react_1.default.createElement("div", { className: myCss.iconAbove + ' labelIcon' }, iconAbove)),
        !!icon && !loading && (react_1.default.createElement("div", { style: { marginRight: !!children || !!label ? 4 : 0 }, className: myCss.icon + ' labelIcon' }, icon)),
        loading && (react_1.default.createElement("div", { style: { marginRight: !!children || !!label ? 8 : 0 } },
            react_1.default.createElement(Dots_1.default, null))),
        !!label && react_1.default.createElement("div", { className: myCss.labelText + ' labelText' }, label),
        !label && !!children && !loading && (react_1.default.createElement("div", { style: { minWidth: minLabelWidth } }, children)),
        !!iconRight && (react_1.default.createElement("div", { style: { marginLeft: !!children || !!label ? 4 : 0 }, className: myCss.icon + ' labelIcon' }, iconRight)))), [badgeCount, children, icon, iconAbove, iconRight, label, loading, minLabelWidth, myCss]);
    return (0, react_1.useMemo)(() => {
        const contents = tooltip ? (react_1.default.createElement(Tooltip_1.default, { enterDelay: 750, style: { height: '100%', maxWidth: '100%' }, tip: tooltip }, innards)) : (innards);
        return (react_1.default.createElement(Button_1.default, { ref: ref, centerRipple: true, style: style, onClick: handleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, component: component, fullWidth: fullWidth, classes: {
                root: myCss.root + ' newStyle',
                label: myCss.label,
            }, disabled: disabled, type: submit ? 'submit' : undefined, tabIndex: tabIndex, href: href, target: target }, contents));
    }, [
        component,
        disabled,
        fullWidth,
        handleClick,
        href,
        innards,
        myCss,
        onMouseEnter,
        onMouseLeave,
        ref,
        style,
        submit,
        tabIndex,
        target,
        tooltip,
    ]);
});
exports.default = exports.Button;
